<template>
  <div class="agenda-detail-common">
    <div v-if="isFetching" class="page-loader">
      <c-loader />
    </div>

    <!--       ERROR -->
    <div v-else-if="!isFetching && errorStatus">
      <ErrorPage :status="errorStatus"/>
    </div>

    <div v-else>
      <!-- header mobile -->
      <div class="agenda-detail-header-mobile">
        <div>
          <c-button
            theme="default"
            size="sm"
            @click="goBack()"
          >
            <i class="fa-regular fa-arrow-left"></i>
          </c-button>
          <strong style="margin-left: var(--attendee-gap-sm);">
          <span style="font-weight: inherit;" v-if="!currentSession.in_progress">
            {{formatDateToShortString()}},
          </span>{{ currentSession.period_formatted }}
          </strong>
        </div>

        <div class="agenda-detail-header-mobile-status">
          <colored-status
            v-if="currentSession.in_progress && !hideButtons"
            color="#e2544d"
          >In Progress</colored-status>

          <span  class="agenda-detail-header-mobile__status" v-show="currentSession.not_registered_for">
            <i class="fa-regular fa-lock-keyhole" style="color: purple;  margin-left: 5px;" ></i>
        </span>

          <!--        <span v-show="NOT_MEET" class="agenda-detail-header-mobile__status" v-tooltip="sessionStatuses.NOT_MEET_THRESHOLD">-->
          <!--            <i class="fa-duotone fa-solid fa-square-info" style=" font-size: 20px; color: gray;"></i>-->
          <!--        </span>-->

          <span>
          <colored-status
            v-if="currentSession.buttons?.evaluation?.completed && !hideButtons"
            color="green"
          >Completed</colored-status>
        </span>


          <!--        <div class="agenda-detail-header-mobile__status" v-if="!hideButtons">-->
          <!--          <colored-status-->
          <!--              color="#e2544d"-->
          <!--              v-if="currentSession.buttons?.evaluation?.threshold_failed"-->
          <!--          >{{ sessionStatuses.NOT_MEET_THRESHOLD }}</colored-status>-->
          <!--        </div>-->

          <!--        <div class="agenda-detail-header-mobile__status"  v-if="!hideButtons">-->
          <!--          <colored-status-->
          <!--              color="#e2544d"-->
          <!--              v-if="currentSession.not_registered_for"-->
          <!--          >{{ sessionStatuses.NOT_REGISTERED }}</colored-status>-->
          <!--        </div>-->



        </div>

      </div>

      <div class="agenda-detail-header">
        <div class="agenda-detail-header__title">
          <h4>
            <!--          DESKTOP ONLY -->
            <div class="agenda-detail-header__back">
              <c-button
                theme="default"
                size="sm"
                @click="goBack()"
              >
                <i class="fa-regular fa-arrow-left"></i>
              </c-button>
            </div>
            {{ currentSession?.name }}

            <!-- MOBILE ONLY -->
            <div v-if="!hideButtons" class="agenda-detail-header-schedule-buttons">
              <agenda-schedule-buttons-mobile
                v-if="attendee?.tabs?.my_agenda"
                :show-scheduler-indicator="showSchedulerIndicator"
                :enabled="currentSession.buttons?.my_schedule?.enabled"
                :completed="currentSession.buttons?.my_schedule?.completed"
                :can-delete="currentSession.buttons?.my_schedule?.can_delete"
                @updateScheduler="updateScheduler(currentSession)"
              />
            </div>

            <div class="agenda-detail-header__title--status">
              <!-- DESKTOP ONLY -->
              <div v-if="currentSession.in_progress && !hideButtons" class="agenda-detail-header__in_progress">
                <colored-status
                  color="#e2544d">In Progress</colored-status>
              </div>

              <div v-if="currentSession.not_registered_for && !hideButtons"
                   v-tooltip="sessionStatuses.NOT_REGISTERED"
                   class="agenda-detail-header__in_progress">
                <i class="fa-regular fa-lock-keyhole" style="color: gray; margin-left: 5px;" ></i>
              </div>


              <!--            <span v-show="NOT_MEET" class="agenda-detail-header__in_progress" v-tooltip="sessionStatuses.NOT_MEET_THRESHOLD">-->
              <!--              <i class="fa-duotone fa-solid fa-square-info" style=" font-size: 20px; color: gray;"></i>-->
              <!--            </span>-->

            </div>

          </h4>
        </div>

        <div class="buttons-group mobile-only">

          <div class="buttons-wrapper" v-if="currentSession?.buttons?.virtual_session?.enabled && !hideButtons">
            <div class="buttons-wrapper__buttons">
              <c-button
                uppercase
                fill
                icon="fa-solid fa-network-wired"
                theme="success"
                size="sm"
                :href="currentSession?.buttons?.virtual_session?.link"
              >
                Join Virtual Session
              </c-button>
            </div>
          </div>

          <div class="buttons-wrapper ">
            <div v-if="currentSession.buttons?.discussion?.enabled && !hideButtons"  class="buttons-wrapper__buttons">
              <c-button
                uppercase
                fill
                icon="fa-solid fa-comments"
                theme="purple"
                size="sm"
                :href="`${currentSession.buttons?.discussion?.link}&attendeeId=${attendeeId}`"
              >
                Discussion
              </c-button>
            </div>
          </div>

          <div class="evaluation-attended-wrapper mobile-only">
            <!-- ATTENDED, JOIN SESSION BUTTONS    -->
            <div
              class="buttons-wrapper__buttons"
              v-if="
              !currentSession.buttons?.evaluation?.completed
              && currentSession.buttons?.evaluation?.quiz?.enabled
              && !currentSession.buttons?.evaluation?.quiz?.completed
              && !currentSession.buttons?.evaluation?.quiz?.is_failed
              && !hideButtons
            "
            >
              <c-button
                uppercase
                fill
                theme="warning"
                icon="fa-solid fa-ballot-check"
                size="sm"
                @click="goTo('quiz', currentSession.id)"
                :disabled="NOT_MEET"
                v-tooltip='{content: sessionStatuses.NOT_MEET_THRESHOLD, visible: NOT_MEET}'
              >
                Start Quiz
              </c-button>
            </div>

            <div
              class="evaluation-attended-wrapper__button evaluation-attended-wrapper__button--badged"
              v-if="(currentSession.buttons?.evaluation?.enabled && currentSession.buttons?.evaluation?.available && !hideButtons) || NOT_MEET" >
              <c-button
                uppercase
                fill
                theme="primary"
                icon="fa-solid fa-comments-question"
                size="sm"
                @click="goTo('evaluation', currentSession.id)"
                :disabled="NOT_MEET || EVALUATION_EXPIRED"
                v-tooltip='{content: sessionStatuses.NOT_MEET_THRESHOLD, visible: NOT_MEET}'
              >
                {{currentSession.buttons?.evaluation?.button_name || 'Start Evaluation'}}
              </c-button>

              <span
                  v-if="EVALUATION_EXPIRATION_DATE && !NOT_MEET"
                  class="eval-expiration-badge"
                  v-tooltip="expirationBadgeTooltip"
              >?</span>
            </div>

            <div class="evaluation-attended-wrapper__button" v-if="currentSession.buttons?.attended_session?.enabled && !hideButtons">
              <agenda-attended-buttons
                :completed="currentSession.buttons?.attended_session?.completed"
                :enabled="currentSession.buttons?.attended_session?.enabled"
                :is-overlap="currentSession.buttons?.attended_session?.is_overlap"
                :attendee-id="attendeeId"
                :session-id="currentSession.id"
                @success="attendedSuccess"
                :code="currentSession.buttons?.evaluation?.code"
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentSession?.name" class="session-content">
        <div>
          <div v-if="currentSession?.is_virtual_session" style="margin-bottom: var(--attendee-gap-md);">
            <marked-status
              icon="fa-video"
            >Virtual Room</marked-status>
          </div>

          <div class="session-content-block">
            <h4 class="session-content-block__data">
              <strong class="desktop-time">{{ currentSession.period_formatted }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
              <strong v-if="!currentSession.is_agenda && !(!currentSession.is_educational && +currentSession.credit_hours === 0)">
                {{ currentSession.is_educational ? 'CE' : '' }} Hours: {{ currentSession.credit_hours }}
              </strong>
              <span v-if="currentSession.topics?.length" v-for="(topic, topicIndex) in currentSession.topics" :key="`topic-${topicIndex}`">
             <marked-status
               style="margin-bottom: 7px;"
               :withBorder="true"
             >{{ topic.title }} <span v-if="topic.hours">({{topic.hours}})</span></marked-status>&nbsp;
            </span>
            </h4>
          </div>

          <!-- approved -->
          <agenda-approvals
            v-if="currentSession.is_educational"
            color="rgb(1 128 1)"
            icon="fa-shield-check"
            type="approved"
            :approvals="currentSession.approvals?.approved"
          />
          <!-- pending -->
          <agenda-approvals
            v-if="currentSession.is_educational"
            color="rgb(255, 176, 66)"
            icon="fa-shield-exclamation"
            type="pending"
            :approvals="currentSession.approvals?.pending"
          />
          <!-- not_approved -->
          <agenda-approvals
            v-if="currentSession.is_educational"
            color="rgb(255, 102, 102)"
            icon="fa-ban"
            type="not_approved"
            :approvals="currentSession.approvals?.not_approved"
          />


          <div class="session-data-line" v-if="currentSession?.room?.name">
            <strong> Room:</strong>
            <span>
            <marked-status>{{ currentSession.room.name }}</marked-status>
          </span>
          </div>

          <div class="session-data-line" v-if="currentSession?.format">
            <strong> Format:</strong>
            <span class="session-format" style="text-transform: capitalize;">
            <marked-status>{{ currentSession.format }}</marked-status>
          </span>
          </div>

          <!-- tracks -->
          <div class="session-data-line" v-if="currentSession.tracks?.length">
            <strong> Tracks:</strong>
            <span v-for="(track, trackIndex) in currentSession.tracks" :key="`track-${trackIndex}`">
            <marked-status
              :marker-color="track.color"
            >{{ track.name }}</marked-status>&nbsp;
            </span>
          </div>

          <!-- topics -->
          <!--        <div class="session-data-line" v-if="currentSession.topics?.length">-->
          <!--          <i class="fa-regular fa-newspaper"></i><strong> Topics:</strong>-->
          <!--         -->
          <!--        </div>-->

          <div class="session-content-block" v-if="currentSession.description" style="margin-top: 20px;">
            <h4 class="session-content-block__title">Description</h4>
            <div v-if="currentSession.description.length > 300">
              <div class="session-content-block__data" v-if="!showMoreFlag" style="white-space: pre-wrap;">{{limitTo(currentSession.description, 300)}} <span class="show-more-button"  @click="showMore">Show More</span>
              </div>
              <div class="session-content-block__data" style="white-space: pre-wrap;" v-else>{{ currentSession.description }} <span class="show-more-button" @click="showLess">Show less</span>
              </div>
            </div>
            <div class="session-content-block__data" style="white-space: pre-wrap;" v-else>{{ currentSession.description }}
            </div>
          </div>

          <div
            class="session-content-block"
            v-if="currentSession?.learningLevels?.length"
          >
            <h4 class="session-content-block__title">Learning Levels</h4>
            <div class="session-content-block__data">
              <ul>
                <li
                  v-for="(item, itemIndex) in currentSession.learningLevels"
                  :key="`level-${itemIndex}`"> {{ item.content }}</li>
              </ul>
            </div>
          </div>

          <div
            class="session-content-block"
            v-if="currentSession?.learningObjectives?.length"
          >
            <h4 class="session-content-block__title">Learning Objectives</h4>
            <div class="session-content-block__data">
              <ul>
                <li v-for="(item, itemIndex) in currentSession.learningObjectives" :key="`objective-${itemIndex}`">
                  {{ item.content }}
                </li>
              </ul>
            </div>
          </div>

          <a
            v-if="currentSession?.references?.length"
            class="session-references"
            href="#"
            @click.prevent.stop="isReferencesModalOpen = true"
          >References</a>

          <c-modal
            v-if="isReferencesModalOpen"
            title="References"
            size="lg"
            @close="isReferencesModalOpen = false"
          >
            <div class="modal-body">
              <div class="session-content-block">
                <div class="session-content-block__data">
                  <ul>
                    <li
                      v-for="(item, itemIndex) in currentSession.references"
                      :key="`reference-${itemIndex}`">{{ item.content }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <c-button
                uppercase
                fill
                theme="default"
                size="sm"
                icon="fa-close"
                @click="isReferencesModalOpen = false"
              >Close</c-button>
            </div>
          </c-modal>
        </div>

        <!-- right side -->
        <div class="left-side">
          <!-- speakers -->
          <div v-if="currentSession?.presenters?.length" class="session-content-block">
            <h4 class="session-content-block__title">Speakers</h4>
            <div class="session-content-block__data">
              <ul class="agenda-detail-presenters">
                <li v-for="presenter in currentSession.presenters">
                  <speaker-short-card
                    :name="presenter.name"
                    :title="presenter.title"
                    :photo="presenter.photo_url"
                    @click.native="onOpenSpeakerModal(presenter)"
                  />
                </li>
              </ul>
            </div>
          </div>
          <br />

          <!-- materials -->
          <div v-if="currentSession?.materials?.length && !hideButtons" class="session-content-block">
            <h4 class="session-content-block__title">Materials</h4>


            <material-list @open="openMaterialModal" :materials="currentSession.materials"/>

          </div>

          <speaker-modal
            v-if="showSpeakerModal"
            :showModal.sync="showSpeakerModal"
            :speaker="selectedSpeaker"
          />

          <!-- material modal -->
          <c-modal
            v-if="showMaterialModal"
            :title="material.title"
            size="lg"
            @close="closeMaterialModal"
          >
            <div class="modal-body">
              <div v-if="isFetchingMaterial" class="agenda-page-loader">
                <c-loader />
              </div>

              <material-preview v-else :material="material" />
            </div>
            <div class="modal-footer">
              <c-button
                uppercase
                fill
                theme="default"
                size="sm"
                icon="fa-close"
                @click="closeMaterialModal"
              >Close</c-button>
            </div>
          </c-modal>
        </div>
      </div>


      <div class="agenda-detail-footer desktop-only">


        <!-- ADD REMOVE SCHEDULER -->
        <div class="agenda-detail-footer__left">
          <agenda-schedule-buttons
            v-if="attendee?.tabs?.my_agenda && currentSession?.buttons?.my_schedule?.enabled && !hideButtons"
            :enabled="currentSession?.buttons?.my_schedule?.enabled"
            :completed="currentSession?.buttons?.my_schedule?.completed"
            :can-delete="currentSession.buttons?.my_schedule?.can_delete"
            :show-scheduler-indicator="showSchedulerIndicator"
            @updateScheduler="updateScheduler(currentSession)"
          />

          <div v-if="co_occurring">
            <co-occurring-modal :sessions="co_occurring.sessions" :title="co_occurring.flash" @close="co_occurring = null" @agree="updateScheduler(currentSession, {agree: true})"/>
          </div>
        </div>


        <div class="agenda-detail-footer__right">
          <c-button
            v-if="currentSession.buttons?.discussion?.enabled && !hideButtons"
            uppercase
            fill
            icon="fa-solid fa-comments"
            theme="purple"
            size="sm"
            :href="`${currentSession.buttons?.discussion?.link}&attendeeId=${attendeeId}`"
          >
            Discussion
          </c-button>

          <c-button
            v-if="currentSession?.buttons?.virtual_session?.enabled && !hideButtons"
            uppercase
            fill
            icon="fa-solid fa-network-wired"
            theme="success"
            size="sm"
            :href="currentSession?.buttons?.virtual_session?.link"
          >
            Join Virtual Session
          </c-button>

          <c-button
            v-if="
              currentSession.buttons?.evaluation?.completed
              && currentSession.buttons?.evaluation?.quiz?.enabled
              && !currentSession.buttons?.evaluation?.quiz?.completed
              && !currentSession.buttons?.evaluation?.quiz?.is_failed
              && !hideButtons
            "
            uppercase
            fill
            theme="warning"
            icon="fa-solid fa-ballot-check"
            size="sm"
            @click="goTo('quiz', currentSession.id)"
            :disabled="NOT_MEET"
            v-tooltip='{content: sessionStatuses.NOT_MEET_THRESHOLD, visible: NOT_MEET}'
          >
            Start Quiz
          </c-button>


          <span
            v-if="(currentSession.buttons?.evaluation?.enabled && currentSession.buttons?.evaluation?.available && !hideButtons) || NOT_MEET"
            class="eval-badge-wrap"
          >
            <c-button
              uppercase
              fill
              theme="primary"
              icon="fa-solid fa-comments-question"
              size="sm"
              @click="goTo('evaluation', currentSession.id)"
              :disabled="NOT_MEET || EVALUATION_EXPIRED"
              v-tooltip='{content: sessionStatuses.NOT_MEET_THRESHOLD, visible: NOT_MEET}'
            >
              {{currentSession.buttons?.evaluation?.button_name || 'Start Evaluation'}}
            </c-button>

            <span
              v-if="EVALUATION_EXPIRATION_DATE && !NOT_MEET && !hideButtons"
              class="eval-expiration-badge"
              v-tooltip="expirationBadgeTooltip"
            >?</span>
          </span>


          <c-button
            v-if="currentSession.buttons?.evaluation?.completed && !hideButtons"
            uppercase
            fill
            theme="success"
            size="sm"
            icon="fa-solid fa-comments-question"
          >Evaluation Completed</c-button>

          <agenda-attended-buttons
            v-if="currentSession.buttons?.attended_session?.enabled && !hideButtons"
            :completed="currentSession.buttons?.attended_session?.completed"
            :enabled="currentSession.buttons?.attended_session?.enabled"
            :is-overlap="currentSession.buttons?.attended_session?.is_overlap"
            :attendee-id="attendeeId"
            :session-id="currentSession.id"
            @success="attendedSuccess"
            :code="currentSession.buttons?.evaluation?.code"
          />
        </div>



      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ColoredStatus from "../ui/ColoredStatus";
import SpeakersShortList from "../speakers/SpeakersShortList";
import MarkedStatus from "../ui/MarkedStatus";
import agendaAPI from "../../api/agendaAPI";
import MaterialPreview from "../../views/agenda/event-agenda/event-agenda-detail/material-preview";
import AgendaApprovals from "../../views/agenda/common/agenda-approvals";
import AgendaScheduleButtons from "./agenda-schedule-buttons";
import AgendaAttendedButtons from "./agenda-attended-buttons";
import {formatDateToShortString} from "../../helpers/date";
import AgendaVerificationForm from "./agenda-verification-form";
import SpeakerShortCard from "../speakers/SpeakerShortCard";
import SpeakerModal from '../../views/agenda/common/speaker-modal.vue'
import {limitTo} from "../../helpers/limitTo";
import AgendaScheduleButtonsMobile from "./agenda-schedule-buttons-mobile";
import { SESSION_STATUSES } from "../../constants/messages";
import MaterialList from "../common/material-list";
import ErrorPage from "../../views/error-page";
import CoOccurringModal from "../../views/agenda/common/co-occurring-modal";

export default {
  props: {
    hideButtons: {
      type: Boolean,
      default: false
    },
  },
  components: {
    CoOccurringModal,
    SpeakerModal,
    ColoredStatus,
    SpeakersShortList,
    MarkedStatus,
    MaterialPreview,
    AgendaApprovals,
    AgendaScheduleButtons,
    AgendaVerificationForm,
    AgendaAttendedButtons,
    AgendaScheduleButtonsMobile,
    SpeakerShortCard,
    MaterialList,
    ErrorPage,
  },
  mounted() {
    this.fetch();
  },
  computed: {
    ...mapGetters('attendeeStore', ['attendee', 'isSingleSession']),

    sessionStatuses() {
      return SESSION_STATUSES;
    },
    NOT_MEET(){
      return this.currentSession.buttons?.evaluation?.threshold_failed
    },

    EVALUATION_EXPIRED() {
      return this.currentSession.buttons?.evaluation?.expired
    },

    EVALUATION_EXPIRATION_DATE() {
      return this.currentSession.buttons?.evaluation?.expiration_date
    },

    expirationBadgeTooltip() {
      return this.EVALUATION_EXPIRED
        ? this.sessionStatuses.EVALUATION_EXPIRED
        : 'Evaluation available until\n' + this.EVALUATION_EXPIRATION_DATE
    }
  },
  data() {
    return {
      co_occurring: null,
      errorStatus: null,
      isFetching: false,
      attendeeId: this.$route.params.attendeeId,
      currentSession: {},
      isReferencesModalOpen: false,
      showSchedulerIndicator: false,
      addedToScheduler: false,

      showMoreFlag: false,

      // material
      isFetchingMaterial: false,
      material: {
        embed_code: '',
        url: '',
        allow_download: '',
        uuid_url: '',
        original_filename: '',
        name: '',
      },
      showMaterialModal: false,
      showSpeakerModal: false,
      selectedSpeaker: null,
    };
  },
  methods: {
    onOpenSpeakerModal(speaker) {
      this.selectedSpeaker = speaker;
      this.showSpeakerModal = true;
    },

    limitTo: (...arg) => {
      return limitTo(...arg);
    },

    showMore() {
      this.showMoreFlag = true
    },

    showLess() {
      this.showMoreFlag = false
    },

    attendedSuccess(sessions) {
      sessions.forEach((session) => {
        if (session.id === this.currentSession.id) {
          this.currentSession.buttons = session.buttons;
        }
      });
    },

    formatDateToShortString(){
      return formatDateToShortString(this.currentSession.start_at)
    },

    updateScheduler(session, params = {}) {
      this.showSchedulerIndicator = true;

      if (session?.buttons?.my_schedule?.completed) {
        agendaAPI.removeFromScheduler(this.attendeeId, this.currentSession.id)
          .then(() => {
            session.buttons.my_schedule.completed = !session.buttons.my_schedule.completed;
            session.my_agenda = !session.my_agenda;

            this.$store.dispatch("agendaStore/updateFlatSessionById", {id: session.id, session: session});
            this.$store.dispatch('attendeeStore/updateMyAgendaCount',{count: -1});
          })
          .catch(() => {})
          .finally(() => {
            this.showSchedulerIndicator = false;
          });
      } else {
        agendaAPI.addToScheduler(this.attendeeId, this.currentSession.id, params)
          .then(() => {
            this.co_occurring = null;

            session.buttons.my_schedule.completed = !session.buttons.my_schedule.completed;
            session.my_agenda = !session.my_agenda;

            this.$store.dispatch("agendaStore/updateFlatSessionById", {id: session.id, session: session});
            this.$store.dispatch('attendeeStore/updateMyAgendaCount',{count: 1});
          })
          .catch((error) => {

            if(error.response.status === 422){
              console.log(error.response.data.flash);
              this.co_occurring = error.response.data;
            }
            console.log(error.response);

          })
          .finally(() => {
            this.showSchedulerIndicator = false;
          });
      }
    },

    openMaterialModal(materialId) {
      this.showMaterialModal = true;

      this.fetchMaterial(materialId);
    },

    closeMaterialModal() {
      this.material = {
        embed_code: '',
        url: '',
        allow_download: '',
        uuid_url: '',
        original_filename: '',
        name: '',
      };
      this.showMaterialModal = false;
    },

    fetchMaterial(materialId) {
      this.isFetchingMaterial = true;

      agendaAPI.fetchSessionMaterial(this.attendeeId, this.$route.params.sessionId, materialId)
        .then((res) => {
          this.material = res.data.data;
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingMaterial = false;
        });
    },

    fetch() {
      this.isFetching = true;
      this.errorStatus = null;
      agendaAPI.fetchSessionByID(this.attendeeId, this.$route.params.sessionId)
        .then((res) => {
          this.currentSession = res.data.data;
        })
        .catch((error) => {
          this.errorStatus = error?.response?.status;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },

    goBack() {
      // Prefer real browser back — this enables Vue Router's savedPosition
      if (window.history.length > 1) {
        this.$router.back();
        return;
      }

      // Fallback to your named routes (first-load or no history)
      let page = this.$route.query.back;

      if (page === 'My Certificate' && this.isSingleSession) {
        page = 'Single Event';
      } else if (!page) {
        page = 'Speakers';
      }

      this.$router.push({ name: page });
    },

    goTo(page, sessionId) {
      if (page === 'evaluation') {
        this.$router.push({name: "Session Evaluation", params: {sessionId: sessionId}, query: {back: this.$route.name}});
      } else if (page === 'quiz') {
        this.$router.push({name: "Session Quiz", params: {sessionId: sessionId}, query: {back: this.$route.name}});
      }
    },
  },
};
</script>

<style lang="scss">
.mobile-only {
  @media (min-width: 900px) {
    display: none !important;
  }
}

.evaluation-attended-wrapper__button--badged {
  position: relative;
}

.eval-badge-wrap {
  position: relative;
  display: block;
}

.eval-expiration-badge {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #e2544d;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  cursor: help;
  z-index: 2;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
}

.desktop-only {
  @media (max-width: 900px) {
    display: none !important;
  }
}

.agenda-detail-footer {
  padding: var(--attendee-gap-md);
  position: sticky;
  background-color: white;
  margin: 0 calc(var(--attendee-gap-md) * -1);
  bottom: 0;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--attendee-gap-md);

  &__left {
    display: flex;
    flex-wrap: wrap;
    gap: var(--attendee-gap-sm);
  }

  &__right {
    display: flex;
    flex-wrap: wrap;
    gap: var(--attendee-gap-sm);
  }
}

.show-more-button {
  color: var(--attendee-brand-color);
  text-decoration: underline;
  cursor: pointer;
}

.agenda-detail-presenters {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0 !important;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }

  li {
    list-style: none !important;
  }
}

.agenda-detail-common {
  position: relative;

  .session-data-line {
    margin-bottom: var(--attendee-gap-sm);
    font-size: 16px;

    strong {
      font-size: 16px;
    }

    svg {
      @media (max-width: 900px) {
        display: none;
      }
    }

  }

  .evaluation-attended-wrapper {
    display: flex;
    justify-content: space-between;
    //align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    @media (max-width: 900px) {
      display: flex;
      justify-content: center;
      padding: 0 5px;

      fragment, button, a {
        width: 100%;
      }

      > div {
        flex: 1; // по замовчуванню всі кнопки розтягуються
      }

      > div:last-child:nth-child(2) {
        // це спрацює тільки якщо друга кнопка є (тобто всього 2 кнопки)
        flex: 0 0 40px;
        width: 40px;
      }
    }
  }

  .buttons-wrapper {
    display: flex;
    justify-content: space-between;
    //align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    @media (max-width: 900px) {
      display: flex;
      justify-content: center;
      padding: 0 5px;
    }

    &:has(:nth-child(2):nth-last-child(1)) {
      > * {
        flex: 1 1 50%; // Якщо 2 елементи — по 50%
      }
    }
    &__buttons {
      @media (max-width: 900px) {
        //flex: 0 1 auto;
        //flex: 0 0 50%;
        flex-wrap: wrap;
        flex: 1 1 100%;
        //margin: 0 -5px;

        button, fragment, a, .agenda-footer__button{
          display: block;
          width: 100%;
        }
      }
    }
  }

  .rest-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    // verification form wrapper
    >span{
      width: 100%;
    }

    button, fragment, a {
      display: block;
      width: 100%;
    }
  }

  .desktop-time {
    @media (max-width: 900px) {
      display: none;
    }
  }

  .agenda-detail-header-mobile {
    display: none;
    justify-content: space-between;
    //align-items: center;
    //margin-bottom: var(--attendee-gap-md);
    gap: var(--attendee-gap-sm);

    background-color: white;
    position: sticky;
    padding: var(--attendee-gap-md);
    margin: 0 calc(var(--attendee-gap-md) * -1);
    z-index: 10;

    top: 50px;

    .agenda-detail-header-mobile-status{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
    }

    &__status{
      margin-bottom: var(--attendee-gap-sm);
      display: inline-block;
      max-width: 167px;
    }

    @media (max-width: 900px) {
      display: flex;
    }
  }

  .agenda-detail-header {
    padding: var(--attendee-gap-md);
    background-color: white;
    position: sticky;
    top: 110px;
    display: grid;
    grid-template-columns: auto auto;
    justify-content: space-between;
    grid-gap: var(--attendee-gap-md);
    align-items: center;
    //margin-bottom: var(--attendee-gap-md);
    margin: 0 calc(var(--attendee-gap-md) * -1);

    @media (max-width: 900px) {
      display: block;
      position: initial;
      padding-top: 0;
    }

    &__title {
      h4 {
        display: grid;
        color: var(--attendee-brand-color);
        grid-template-columns: auto auto auto;
        grid-gap: var(--attendee-gap-md);
        align-items: center;


        .agenda-detail-header__title--status{

        }

        @media (max-width: 900px) {
          grid-template-columns: auto auto ;
          justify-content: space-between;
        }

        .agenda-detail-header__back {
          @media (max-width: 900px) {
            display: none;
          }
        }
      }

      @media (max-width: 900px) {
        margin-bottom: var(--attendee-gap-md);
      }


      .agenda-detail-header-schedule-buttons{
        display: none;

        @media (max-width: 900px) {
          display: block;
        }
      }
    }

    &__in_progress {
      max-width: 167px;
      display: inline-block;
      margin-bottom: var(--attendee-gap-sm);
      margin-top: var(--attendee-gap-sm);
      @media (max-width: 900px) {
        display: none;
      }
    }
  }


  .buttons-group {

    @media (min-width: 767px) {
      display: flex;
      justify-content: flex-end;
      //align-items: center;
      flex-wrap: wrap;
      gap: 5px;
    }
  }

  .session-detail-badges {
    margin-bottom: var(--attendee-gap-md);
    display: inline-block;
  }

  .left-side {
    width: 100%;
    overflow: hidden;
  }

  .session-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 70px;

    @media (max-width: 1100px) {
      grid-template-columns: 1fr;
      gap: 40px;
    }
  }

  .session-format {
    text-transform: capitalize;
  }

  .session-references {
    color: var(--attendee-brand-color);
    text-decoration: underline;
    font-size: 21px;
    font-weight: 600;
  }
}
</style>
